import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { Subject } from 'rxjs';

@Component({
  selector: 'yes-no-unknown',
  templateUrl: './yes-no-unknown.component.html',
  styleUrls: ['./yes-no-unknown.component.scss'],
})
export class YesNoUnknownComponent implements OnInit, OnChanges {
  showInstructionOn: boolean;
  formGroup: UntypedFormGroup;
  @Input()
  public title: string;
  @Input()
  public subtitle: string;
  @Input()
  public yesLabel = 'Ja';
  @Input()
  public noLabel = 'Nee';
  @Input()
  public unknownLabel = 'Ik weet het niet';
  @Input()
  public extraInstructions = 'Geef hier extra uitleg';
  @Input()
  public showExtraInstructionsOn: boolean = true;
  @Input()
  public alwaysShowExtraInstructions = false;
  @Input()
  public neverShowExtraInstructions = false;
  @Input()
  public inputText: string;
  @Input()
  public sensitiveText: boolean = false;
  @Input()
  public value: boolean = null;
  @Input()
  public flexRow = true;
  @Input()
  public answerChange: Subject<boolean>;
  @Input()
  public answeredTextChange: Subject<string>;
  @Input()
  public disabled = false;
  @Input()
  public disabledYes = false;
  @Input()
  public tooltipYes: string;
  @Input()
  public disabledNo = false;
  @Input()
  public tooltipNo: string;
  @Input()
  public disabledUnknown = false;
  @Input()
  public tooltipUnknown: string;
  @Input()
  public client = false;
  @Output()
  public answer = new EventEmitter<boolean>();
  @Output()
  public answeredText = new EventEmitter<string>();

  constructor(private formBuilder: UntypedFormBuilder) {}

  ngOnInit() {
    this.formGroup = this.initYesNoForm();
    if (this.showExtraInstructionsOn !== null) {
      this.showInstructionOn = this.showExtraInstructionsOn === this.value;
    } else {
      this.showInstructionOn = null;
    }
    if (this.answerChange != null) {
      this.answerChange.subscribe((b) => {
        this.value = b;
      });
    }
    if (this.disabled) {
      this.formGroup.controls['answer'].disable();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.formGroup == null) {
      return;
    }
    if (changes.disabled) {
      if (changes.disabled.currentValue === true) {
        this.formGroup.controls['answer'].disable();
      } else {
        this.formGroup.controls['answer'].enable();
      }
    }
  }

  initYesNoForm() {
    return this.formBuilder.group({
      answer: new UntypedFormControl(''),
    });
  }

  answeredYes() {
    this.value = true;
    this.answer.emit(this.value);
  }

  answeredNo() {
    this.value = false;
    this.answer.emit(this.value);
  }

  answeredUnknown() {
    this.value = null;
    this.answer.emit(this.value);
  }

  extraInstructionsChange(value) {
    this.answeredText.emit(value);
  }
}
